import { Injectable } from '@angular/core';
import { LogService, FilteredLogSubscriberService, LogMessage, LogLevel } from './log.service';

@Injectable()
export class ConsoleLogSubscriberService extends FilteredLogSubscriberService {
  constructor(logService: LogService) {
    super(logService);
  }

  public log(logMessage: LogMessage) {
    // Since the LogLevel enum is aligned with the the console function names
    // use the string value to call the corresponding logging function.
    const level = LogLevel[ logMessage.level ].toLowerCase();
    if (console[ level ]) {
      console[ level ](logMessage.message);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/log/console-log-subscriber.service.ts